import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'components/shared/Tooltip'
import styles from './Rail.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const RailItem = ({ item, active, collapsed, onSelect }) => {
  const button = (
    <button
      type="button"
      className={cx(styles.item, active && styles.active)}
      aria-current={active ? 'page' : undefined}
      onClick={e => onSelect(e, item)}
      onMouseEnter={item.onMouseEnter}
    >
      <span className={styles.icon}>{item.icon}</span>
      <span className={styles.label}>{item.label}</span>
      {typeof item.count === 'number' && item.count > 0 && (
        <span className={styles.count}>{item.count}</span>
      )}
    </button>
  )

  return collapsed ? <Tooltip title={item.label} placement="right">{button}</Tooltip> : button
}

const Rail = ({ brand, sections, footerItems, activeId, collapsed, onSelect, onBrandClick, label }) => (
  <nav className={cx(styles.rail, collapsed && styles.collapsed)} aria-label={label}>
    {brand && (
      <button type="button" className={styles.brand} onClick={onBrandClick} aria-label="ROX">
        {brand}
      </button>
    )}

    <div className={styles.nav}>
      {sections.map(section => (
        <React.Fragment key={section.title || 'default'}>
          {section.title && <div className={styles.eyebrow}>{section.title}</div>}
          {section.items.map(item => (
            <RailItem
              key={item.id}
              item={item}
              active={item.id === activeId}
              collapsed={collapsed}
              onSelect={onSelect}
            />
          ))}
        </React.Fragment>
      ))}

      {footerItems && footerItems.length > 0 && (
        <div className={styles.footer}>
          {footerItems.map(item => (
            <RailItem
              key={item.id}
              item={item}
              active={item.id === activeId}
              collapsed={collapsed}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  </nav>
)

const itemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  icon: PropTypes.node,
  count: PropTypes.number,
  onMouseEnter: PropTypes.func,
})

Rail.propTypes = {
  brand: PropTypes.node,
  sections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(itemShape).isRequired,
  })).isRequired,

  footerItems: PropTypes.arrayOf(itemShape),
  activeId: PropTypes.string,
  collapsed: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onBrandClick: PropTypes.func,
  label: PropTypes.string,
}

Rail.defaultProps = { label: 'Main' }

export default Rail
